//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "importOrderDetailMore",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toAll(){
      this.$router.push({name:'importOrderDetailAll'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/importOrder/detailMore.vue